import fetch from '@/utils/fetch'

import {
  login_url,
  shop_url
} from '@/global'

export function loginCode (phoneNumber, type) {
  return fetch({
    url: `${shop_url}/auth/sms`,
    method: 'post',
    data: {
      client: 'CC',
      mobile: phoneNumber,
      type: 6
    }
  })
}
// 登录
export function login (phoneNumber, verifyCode, uuid, loginModel, lng, lat) {
  return fetch({
    url: `${shop_url}/auth/auth/login`,
    method: 'post',
    data: {
      client: 'CC',
      loginType: 'code',
      verifyCodeDto: {
        client: 'cc',
        code: verifyCode,
        mobile: phoneNumber,
        type: 6

      }
      // wechatUnionid: '',
      // qqOpenid: ''
    }
  })
}

export function getCompany () {
  return fetch({
    url: `${shop_url}/shop/app/company`,
    method: 'get'
  })
}
